export type TenantNotificationBanner = {
  banner_id: string;
  org_id: string | null;
  title: string | null;
  message: string;
  know_more_url: string | null;
  starts_at: string;
  ends_at: string;
  timezone_label: string;
  enabled: boolean;
  dismissible: boolean;
  priority: number;
  scope: "platform" | "org";
};

export function formatNotificationBannerWindow(
  startsAt: string,
  endsAt: string,
  timezoneLabel: string,
): string {
  const start = new Date(startsAt);
  const end = new Date(endsAt);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return "";
  }

  const sameDay =
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate();

  const dateOpts: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  const timeOpts: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const startDate = start.toLocaleDateString(undefined, dateOpts);
  const endDate = end.toLocaleDateString(undefined, dateOpts);
  const startTime = start.toLocaleTimeString(undefined, timeOpts);
  const endTime = end.toLocaleTimeString(undefined, timeOpts);
  const zone = timezoneLabel?.trim() || "UTC";

  if (sameDay) {
    return `${startDate}, between ${startTime} to ${endTime} ${zone}`;
  }
  return `${startDate} ${startTime} to ${endDate} ${endTime} ${zone}`;
}

export function dismissedBannerStorageKey(bannerId: string): string {
  return `nd.dismissed-notification-banner.${bannerId}`;
}

export function isBannerDismissed(bannerId: string): boolean {
  try {
    return localStorage.getItem(dismissedBannerStorageKey(bannerId)) === "1";
  } catch {
    return false;
  }
}

export function dismissBanner(bannerId: string): void {
  try {
    localStorage.setItem(dismissedBannerStorageKey(bannerId), "1");
  } catch {
    // ignore quota / private mode
  }
}
